__turbopack_context__.v({
  "button": "quoteFormSuccess-module-scss-module__QTRfvq__button",
  "buttonWrp": "quoteFormSuccess-module-scss-module__QTRfvq__buttonWrp",
  "description": "quoteFormSuccess-module-scss-module__QTRfvq__description",
  "divider": "quoteFormSuccess-module-scss-module__QTRfvq__divider",
  "downloadIcon": "quoteFormSuccess-module-scss-module__QTRfvq__downloadIcon",
  "downloadLink": "quoteFormSuccess-module-scss-module__QTRfvq__downloadLink",
  "downloadWrp": "quoteFormSuccess-module-scss-module__QTRfvq__downloadWrp",
  "print": "quoteFormSuccess-module-scss-module__QTRfvq__print",
  "printIcon": "quoteFormSuccess-module-scss-module__QTRfvq__printIcon",
  "quoteValue": "quoteFormSuccess-module-scss-module__QTRfvq__quoteValue",
  "resultContent": "quoteFormSuccess-module-scss-module__QTRfvq__resultContent",
  "resultWrp": "quoteFormSuccess-module-scss-module__QTRfvq__resultWrp",
  "successMessageWrp": "quoteFormSuccess-module-scss-module__QTRfvq__successMessageWrp",
  "thanksHeaderWrp": "quoteFormSuccess-module-scss-module__QTRfvq__thanksHeaderWrp",
  "tooltip": "quoteFormSuccess-module-scss-module__QTRfvq__tooltip",
});
